"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(param) {
  return encodeURI(decodeURIComponent(param).replace(/:|\.|&/g, '').replace(/ /g, '-').replace(/\//g, '-').replace(/\\/g, '-').replace(/[\])}[{(]/g, '')).toLowerCase();
};
exports["default"] = _default;